@for (toast of toastList(); track toast.id) {
  <div
    id="{{ toast.id }}-wrapper"
    class="app-toasts__toast-wrapper"
    #toastWrapper
    [style.--enter-duration.ms]="enterAnimationTime"
    [style.--leave-duration.ms]="leaveAnimationTime"
    animate.enter="app-toasts__toast-wrapper--enter"
    animate.leave="app-toasts__toast-wrapper--leave"
    (animationend)="onAnimationEnd(toastWrapper, $event, toast)">
    <div
      id="{{ toast.id }}"
      [attr.role]="toast.type === ToastType.Error ? 'alert' : 'status'"
      class="app-toasts__toast"
      [ngClass]="{
        'app-toasts__toast--green': toast.type === ToastType.Success,
        'app-toasts__toast--yellow': toast.type === ToastType.Warning,
        'app-toasts__toast--orange': toast.type === ToastType.Critical,
        'app-toasts__toast--red': toast.type === ToastType.Error,
      }"
      [attr.data-testid]="toast.testId"
      (mouseenter)="toast._hovered = true"
      (mouseleave)="toast._hovered = false">
      <div class="app-toasts__toast-content">
        <span class="app-toasts__icon">
          @if (toast.iconClass) {
            <span [ngClass]="toast.iconClass"></span>
          } @else {
            @switch (toast.type) {
              @case (ToastType.Question) {
                <span class="icon-circle-help"></span>
              }
              @case (ToastType.Success) {
                <span class="icon-circle-checkmark"></span>
              }
              @case (ToastType.Warning) {
                <app-icon-triangle-warning />
              }
              @case (ToastType.Critical) {
                <app-icon-rhomb-warning />
              }
              @case (ToastType.Error) {
                <span class="icon-circle-error"></span>
              }
              @default {
                <span class="icon-circle-information"></span>
              }
            }
          }
        </span>
        <span class="app-toasts__text">
          <span class="app-toasts__title" [innerHTML]="toast.title | translate: toast.titleTranslateParams"></span>
          @if (toast.title && toast.text) {
            <span>&nbsp;</span>
          }
          <span [innerHTML]="toast.text | translate: toast.textTranslateParams"></span>
        </span>
        @if (toast.showCloseButton) {
          <a
            href
            role="button"
            id="{{ toast.id }}-close-button"
            [ariaLabel]="closeButtonAriaLabel()"
            [attr.data-testid]="toast.testId ? toast.testId + '-close' : undefined"
            (click)="$event.preventDefault(); closeToast(toast.id)"
            class="app-toasts__close-button">
            <span class="icon-close"></span>
          </a>
        }
      </div>
      @if (toast.displayTimer) {
        <div
          role="timer"
          aria-valuemin="0"
          aria-valuemax="100"
          [ariaValueNow]="toast._timeRemainingPercent | number: '1.0-0'"
          class="app-toasts__timer"
          [style.--timer.%]="toast._timeRemainingPercent"></div>
      }
    </div>
  </div>
}
